import {Routes} from '@angular/router';
import {NoDirectAccessGuard} from '@core/guards/no-direct-access-guard';
import {AlreadyLoginGuard} from '@core/guards/already-login-guard.service';


export const AuthRoutes: Routes = [
	{
		path: 'jwt/:token',
		loadComponent: () => import('./pages/jwt-login/jwt-login.component').then(m => m.JwtLoginComponent)
	},
	{
		path: 'login',
		canActivate: [AlreadyLoginGuard],
		loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent)
	},
	{
		path: 'vpn',
		canActivate: [AlreadyLoginGuard],
		loadComponent: () => import('./pages/login-vpn/login-vpn.component').then(m => m.LoginVpnComponent)
	},
	{
		path: 'otp',
		canActivate: [NoDirectAccessGuard],
		loadComponent: () => import('./pages/check-otp/check-otp.component').then(m => m.CheckOtpComponent)
	},
	{
		path: 'password',
		children: [
			{
				path: 'recover',
				loadComponent: () => import('./pages/password-recover/password-recover.component').then(m => m.PasswordRecoverComponent)
			},
			{
				path: 'change/:code',
				loadComponent: () => import('./pages/password-change/password-change.component').then(m => m.PasswordChangeComponent)
			},
			{
				path: 'expired',
				canActivate: [NoDirectAccessGuard],
				loadComponent: () => import('./pages/password-expired/password-expired.component').then(m => m.PasswordExpiredComponent)
			},
		]
	},
];
